import { useGuestDamage } from '@/hooks/GuestDamage/useGuestDamage';

import { PhotoModalContainer, PhotoModalOverlay, VideoContainer } from './styles';

interface PhotoModalProps {
  src?: string;
  alt?: string;
  type?: 'image' | 'video';
}
export function PhotoModal({ src, alt, type = 'image' }: PhotoModalProps) {
  const { handleClosePhotoModal } = useGuestDamage();

  return (
    <PhotoModalOverlay onClick={handleClosePhotoModal}>
      <PhotoModalContainer onClick={(e) => e.stopPropagation()}>
        {type === 'video' ? (
          <VideoContainer>
            <video controls autoPlay>
              <source src={src} type="video/mp4" />
              <source src={src} type="video/quicktime" />
              <source src={src} type="video/x-ms-wmv" />
              <source src={src} type="video/webm" />
              <source src={src} type="video/x-flv" />
              Seu navegador não suporta a tag de vídeo.
            </video>
          </VideoContainer>
        ) : (
          <img src={src} alt={alt} />
        )}
      </PhotoModalContainer>
    </PhotoModalOverlay>
  );
}

PhotoModal.defaultProps = {
  src: '',
  alt: '',
  type: 'image',
};
